import { useState, useEffect } from 'react';

const REQUIRED_CHAIN_ID = (process.env.REACT_APP_CHAIN_ID || '0xaa36a7').toLowerCase();

const CHAIN_NAMES = {
  '0x1':      '이더리움 메인넷',
  '0x38':     'BNB 스마트 체인',
  '0x89':     'Polygon 메인넷',
  '0xa':      'Optimism',
  '0xa4b1':   'Arbitrum One',
  '0x7a69':   'Hardhat 로컬 네트워크',
  '0xaa36a7': 'Sepolia 테스트 네트워크',
};

const CHAIN_CONFIG = {
  '0xaa36a7': {
    displayName: 'Sepolia 테스트 네트워크',
    chainName: 'Sepolia test network',
    nativeCurrency: { name: 'SepoliaETH', symbol: 'ETH', decimals: 18 },
    rpcUrls: ['https://rpc.sepolia.org'],
    blockExplorerUrls: ['https://sepolia.etherscan.io'],
  },
  '0x7a69': {
    displayName: 'Hardhat 로컬 네트워크',
    chainName: 'Hardhat',
    nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
    rpcUrls: ['http://127.0.0.1:8545'],
    blockExplorerUrls: [],
  },
};

const requiredConfig = CHAIN_CONFIG[REQUIRED_CHAIN_ID] || CHAIN_CONFIG['0xaa36a7'];

export default function P01Connect({ onConnect }) {
  const [chainId, setChainId] = useState(null);

  useEffect(() => {
    if (!window.ethereum) return;
    window.ethereum.request({ method: 'eth_chainId' })
      .then(id => setChainId(id.toLowerCase()))
      .catch(() => {});
  }, []);

  async function switchToRequiredChain() {
    try {
      await window.ethereum.request({
        method: 'wallet_switchEthereumChain',
        params: [{ chainId: REQUIRED_CHAIN_ID }],
      });
    } catch (err) {
      if (err.code === 4902) {
        try {
          await window.ethereum.request({
            method: 'wallet_addEthereumChain',
            params: [{
              chainId: REQUIRED_CHAIN_ID,
              chainName: requiredConfig.chainName,
              nativeCurrency: requiredConfig.nativeCurrency,
              rpcUrls: requiredConfig.rpcUrls,
              blockExplorerUrls: requiredConfig.blockExplorerUrls,
            }],
          });
        } catch (addErr) {
          console.error('네트워크 추가 오류:', addErr);
        }
      } else {
        console.error('네트워크 전환 오류:', err);
      }
    }
  }

  function openMetaMaskStore() {
    window.open(
      'https://chromewebstore.google.com/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn',
      '_blank',
      'noopener,noreferrer'
    );
  }

  if (!window.ethereum) {
    return (
      <div className="ev-connect-wrap">
        <div className="ev-connect-card">
          <div className="ev-connect-icon">🦊</div>
          <h1 className="ev-connect-title">MetaMask 필요</h1>
          <p className="ev-connect-subtitle">
            이 서비스를 이용하려면 Chrome용 MetaMask 확장 프로그램이 필요합니다.<br />
            아래 버튼을 클릭해 설치 후 페이지를 새로고침해주세요.
          </p>
          <button className="ev-btn ev-btn-primary" style={{ width: '100%' }} onClick={openMetaMaskStore}>
            MetaMask 설치하기 (Chrome 웹 스토어)
          </button>
        </div>
      </div>
    );
  }

  if (chainId !== null && chainId !== REQUIRED_CHAIN_ID) {
    const networkName = CHAIN_NAMES[chainId] || `알 수 없는 네트워크 (${chainId})`;
    return (
      <div className="ev-connect-wrap">
        <div className="ev-connect-card">
          <div className="ev-connect-icon">⚠️</div>
          <h1 className="ev-connect-title">네트워크 변경 필요</h1>
          <div className="ev-network-warning">
            <div className="ev-network-row">
              <span className="ev-network-label">현재 네트워크</span>
              <span className="ev-network-value ev-network-value--bad">{networkName}</span>
            </div>
            <div className="ev-network-row">
              <span className="ev-network-label">필요 네트워크</span>
              <span className="ev-network-value ev-network-value--good">{requiredConfig.displayName}</span>
            </div>
          </div>
          <button className="ev-btn ev-btn-primary" style={{ width: '100%' }} onClick={switchToRequiredChain}>
            {requiredConfig.displayName}로 전환하기
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="ev-connect-wrap">
      <div className="ev-connect-card">
        <div className="ev-connect-icon">🗳️</div>
        <h1 className="ev-connect-title">블록체인 투표 시스템</h1>
        <p className="ev-connect-subtitle">
          {requiredConfig.displayName} 기반의 투명한 온체인 투표 시스템입니다.<br />
          MetaMask 지갑을 연결하여 참여하세요.
        </p>
        <button className="ev-btn ev-btn-primary" style={{ width: '100%', fontSize: '1rem', padding: '14px' }} onClick={onConnect}>
          🦊 MetaMask으로 지갑 연결
        </button>
        {REQUIRED_CHAIN_ID === '0xaa36a7' && (
          <p className="ev-connect-network">
            테스트 ETH가 필요하신가요?&nbsp;
            <a className="ev-connect-link" href="https://sepoliafaucet.com" target="_blank" rel="noopener noreferrer">
              Sepolia Faucet
            </a>
          </p>
        )}
      </div>
    </div>
  );
}
